import React from "react"

import { Link } from "gatsby"
import { useLocation } from '@reach/router'

import styles from "./logo.module.scss"

import logo from "../../images/till-logo.svg"

const Logo = ({ onClick }) => {
  const location = useLocation();
  const { search } = location;
  return (
    <div className={styles.root}>
      <Link to={`/${search}`} onClick={onClick}>
        <img
          src={logo}
          className={styles.svg}
          alt="Till Logo"
          layout="fixed"
        />
      </Link>
    </div>
  )
}

Logo.defaultProps = {
  onClick: () => { },
}

export default Logo;
